/**
 * Who hit this error — as ids only.
 *
 * Before this, no web code called Sentry.setUser, and on 2026-10-07 all 10 web
 * issues that fired in the prior 14 days showed `userCount: 0` in the Sentry API.
 * The error-triage run could not tell "one parent" from "every gym" without
 * digging through Vercel logs. These are the fields it needs to answer that from
 * Sentry alone.
 *
 * IDs ONLY: no name, no email. `sendDefaultPii` stays off, so Sentry does not add
 * an IP address either. The mobile app sends the same tag names
 * (cheervue-mobile-app/utils/monitoring/sentryUserContext.ts) so one Sentry search
 * works across both projects.
 */

export interface SentryUserContextInput {
  userId: string | null | undefined;
  organizationId?: string | null;
  organizationSlug?: string | null;
  /** 'staff' | 'parent' | 'athlete' | 'unknown' on web. */
  userType?: string | null;
  /** The active staff role (owner, admin, coach, …), when there is one. */
  staffRole?: string | null;
}

export interface SentryUserContextSink {
  setUser: (user: { id: string } | null) => void;
  setTag: (key: string, value: string) => void;
}

/**
 * Every tag is always written — `none` when unknown — so a value from the previous
 * gym or the previous login can never linger on the next error.
 */
export function applySentryUserContext(sentry: SentryUserContextSink, input: SentryUserContextInput): void {
  const userId = input.userId || null;
  sentry.setUser(userId ? { id: userId } : null);
  sentry.setTag('org_id', (userId && input.organizationId) || 'none');
  sentry.setTag('org_slug', (userId && input.organizationSlug) || 'none');
  sentry.setTag('user_type', (userId && input.userType) || 'none');
  sentry.setTag('staff_role', (userId && input.staffRole) || 'none');
}
